
import { Vue, Component } from "vue-property-decorator";
import { VMoney } from "v-money";

@Component({
  components: {
    VMoney,
  },

  props: {
    label: String,
    icon: String,
    goTo: String,
    goToAddCard: String,
    goToAddVr: String,
    callback: Function,
    text: String,
    carteiraDependentes: Boolean,
    labelDepedentes: String,
    valorSaldo: String,
    reports: Number,
  },
})
export default class ButtonCard extends Vue {
  money: any = {
    decimal: ",",
    thousands: ".",
    prefix: "R$",
    suffix: "",
    precision: 2,
    masked: false /* doesn't work with directive */,
  };

  buttonClickEvent() {
    this.$emit("buttonCallBack");
  }

  handleClick() {
    if (this.$props.goTo) {
      this.$router.push(this.$props.goTo);
    } else if (this.$props.goToAddCard) {
      sessionStorage.setItem("FLAG_VR", "");
      this.$router.push(this.$props.goToAddCard);
    } else if (this.$props.goToAddVr) {
      sessionStorage.setItem("FLAG_VR", "VOUCHER");
      this.$router.push(this.$props.goToAddVr);
    }
    if (this.$props.callback) this.$props.callback();
  }
}
